import { createAction, props } from '@ngrx/store';
import { Status } from '../models/Status';
import type { fhirR4 } from '@smile-cdr/fhirts';
import { AppStatus } from './app.state';
import { Detail } from '../models/Detail';

export const setInitialValues = createAction(
  '[Landing Component] Set Initial Questionnaire and QR',
  props<{
    questionnaire: fhirR4.Questionnaire;
    questionnaireResponse: fhirR4.QuestionnaireResponse;
    populateError?;
    task?: fhirR4.Task;
  }>(),
);

export const setLogError = createAction(
  '[Landing Component] Set log errors',
  props<{ questionnaireErrors; optional; invalid }>(),
);

export const setPersistentError = createAction(
  '[Landing Component] Set persistent error',
  props<{ persistentError }>(),
);

export const setAutoSave = createAction(
  '[Landing Component] Set AutoSave',
  props<{ autoSave: boolean }>(),
);

export const nextLandingStage = createAction(
  '[Landing Component] Go to next stage',
);

export const setAppStatus = createAction(
  '[Home Component] Set App Status',
  props<{ appStatus: AppStatus }>(),
);
export const setSaveStatus = createAction(
  '[Home Component] Set Save Status',
  props<{ saveStatus: Status | undefined }>(),
);

export const setValidationError = createAction(
  '[Home Component] Set Validation Error',
);

export const updateQr = createAction(
  '[Home Component] Update QuestionnaireResponse',
  props<{
    detail: Detail;
  }>(),
);

export const updateQrSuccess = createAction(
  '[Home Component] Updated QuestionnaireResponse Successfully',
  props<{
    qr: fhirR4.QuestionnaireResponse;
  }>(),
);

export const saveQr = createAction(
  '[Home Component] Save QuestionnaireResponse',
);

export const saveQrSuccess = createAction(
  '[Home Component] QuestionnaireResponse Saved Successfully',
  props<{
    qr: fhirR4.QuestionnaireResponse;
  }>(),
);

export const nextQuestion = createAction(
  '[Home Component] Call $next-question',
  props<{
    qr: fhirR4.QuestionnaireResponse;
  }>(),
);

export const nextQuestionSuccess = createAction(
  '[Home Component] Call $next-question Successfully',
  props<{
    qr: fhirR4.QuestionnaireResponse;
    questionnaire: fhirR4.Questionnaire;
  }>(),
);

export const signQr = createAction(
  '[Home Component] Sign QR and Save',
  props<{
    signature: string;
  }>(),
);

export const createPasBundle = createAction(
  '[Home Component] Create PAS request bundle',
  props<{ qr: fhirR4.QuestionnaireResponse }>(),
);

export const submitPasBundle = createAction(
  '[Home Component] Submit PAS request bundle',
  props<{ bundle: fhirR4.Bundle }>(),
);

export const submitClaimResponse = createAction(
  '[Home Component] Submit ClaimResponse',
  props<{ response: fhirR4.Bundle | fhirR4.OperationOutcome }>(),
);

export const submitPasBundleSuccess = createAction(
  '[Home Component] Submit PAS bundle success',
);

export const submitFailure = createAction(
  '[Home Component] Submit failed',
  props<{ error }>(),
);

export const submitAttachment = createAction(
  '[Home Component] Submit Attachment',
  props<{ task: fhirR4.Task }>(),
);

export const submitAttachmentSuccess = createAction(
  '[Home Component] Submit attachment success',
);

export const setReqFieldCounter = createAction(
  '[Home Component] Set required field counter',
  props<{ counter }>(),
);

export const resetState = createAction('[Logout] Reset state');
